import { CSSObject, SerializedStyles } from '@emotion/react';
import { useToggleState } from '@anytag/shared-hooks';
import { DropdownOption } from '@anytag/shared-types';
import { DropdownSingleSelectMenu, DropdownSingleSelectMenuProps } from '../DropdownMenu';
import { Button, ButtonProps } from './button';

export interface ButtonDropdownSingleSelectProps<T extends DropdownOption>
  extends ButtonProps,
    Pick<DropdownSingleSelectMenuProps<T>, 'options' | 'selectedOption' | 'onSelectOption' | 'side' | 'align'> {
  dropdownClassName?: CSSObject | SerializedStyles;
}

export const ButtonDropdownSingleSelect = <T extends DropdownOption>({
  options,
  selectedOption,
  onSelectOption,
  dropdownClassName,
  side = 'bottom',
  align = 'end',
  ...restProps
}: ButtonDropdownSingleSelectProps<T>) => {
  const { toggleStatus, close } = useToggleState(false);

  const handleSelectOption = (option: T) => {
    onSelectOption(option);
    close();
  };

  return (
    <DropdownSingleSelectMenu
      options={options}
      side={side}
      align={align}
      css={dropdownClassName}
      selectedOption={selectedOption}
      onSelectOption={handleSelectOption}
      trigger={<Button onClick={toggleStatus} {...restProps} />}
    />
  );
};
